<template>
    <div class="rate-change-indicator display-flex align-items-center h-100">
        <font-awesome-icon
            v-if="bin.icon"
            :icon="bin.icon"
            :class="iconColorClass + ' d-inline metric-icon mr-xs'"
            size="lg"
        />
        <p :class="[props.params.colorValue ? textColorClass + ' bold' : '', 'small']">
            {{ props.params.valueFormatted }}
        </p>
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'

const props = defineProps({
    params: {
        type: Object,
        default: () => ({}),
    },
})

const bin = computed(() => {
    if (props.params.value > (props.params.upperBound ?? 0)) {
        return {
            color: 'success',
            icon: 'fas fa-arrow-up-right',
            tooltip: props.params.tooltip?.increasing,
        }
    } else if (props.params.value < (props.params.lowerBound ?? 0)) {
        return {
            color: 'error',
            icon: 'fas fa-arrow-down-right',
            tooltip: props.params.tooltip?.decreasing,
        }
    }
    return {
        color: 'neutral',
        icon: 'fas fa-arrow-right',
        tooltip: props.params.tooltip?.steady,
    }
})

const iconColorClass = computed(() => {
    switch (bin.value.color) {
        case 'success':
            return 'text-success'
        case 'error':
            return 'text-error'
        case 'neutral':
        default:
            return 'text-stone-500'
    }
})

const textColorClass = computed(() => {
    switch (bin.value.color) {
        case 'success':
            return 'text-feedback-success'
        case 'error':
            return 'text-feedback-error'
        case 'neutral':
        default:
            return 'text-stone-500'
    }
})

onMounted(() => {
    props.params.setTooltip(bin.value.tooltip)
})
</script>
